import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './css/invoice.css';
import commaNumber from 'comma-number';

let format = commaNumber.bindWith(',', '.');

const InvoiceBody = ({ saleData, vatOption }) => {
    const classes = useStyles();
    const [saleDetails, setSaleDetails] = useState([]);
    const vatRate = Number(saleData?.sale_vat_percent) || 10;

    useEffect(() => {
        if (saleData?.details) {
            setSaleDetails(saleData.details);
        }
    }, [saleData]);

    const calculateVat = (amount) => {
        const numericAmount = Number(amount) || 0;
        switch (vatOption) {
            case 'A':
                return (numericAmount * vatRate) / 100;
            case 'B':
                return numericAmount - (numericAmount * 100) / (100 + vatRate);
            case 'C': // No VAT
                return 0;
            default:
                return (numericAmount * vatRate) / 100;
        }
    };

    const getBaseAmount = (amount) => {
        const numericAmount = Number(amount) || 0;
        if (vatOption === 'B') {
            return (numericAmount * 100) / (100 + vatRate);
        }
        return numericAmount;
    };

    const getVatPercentage = () => {
        switch (vatOption) {
            case 'A': return `${vatRate}%`;
            case 'B': return `${vatRate}% (Excluded)`;
            case 'C': return '0%';
            default: return `${vatRate}%`;
        }
    };

    const getPriceColumnLabel = () => {
        switch (vatOption) {
            case 'A': return 'Price Including VAT';
            case 'B': return 'Price Excluding VAT';
            case 'C': return 'Price Including VAT';
            default: return 'Price Including VAT';
        }
    };

    const subTotalTotal = saleDetails.reduce(
        (acc, detail) => acc + getBaseAmount(detail.sale_prod_total),
        0
    );

    const subTotalVat = saleDetails.reduce(
        (acc, detail) => acc + calculateVat(detail.sale_prod_total),
        0
    );

    const subTotalPrice =
        vatOption === 'A'
            ? subTotalTotal + subTotalVat
            : saleDetails.reduce((acc, detail) => acc + (Number(detail.sale_prod_total) || 0), 0);

    return (
        <table className={'invoice-table'}>
            <thead>
                <tr>
                    <th style={{ textAlign: 'left' }}>SL</th>
                    <th style={{ textAlign: 'left' }}>Category</th>
                    <th style={{ textAlign: 'left' }}>Product</th>
                    <th style={{ textAlign: 'left' }}>Brand</th>
                    <th>Unit</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Total</th>
                    <th>VAT</th>
                    <th>VAT in BDT</th>
                    <th>{getPriceColumnLabel()}</th>
                </tr>
            </thead>
            <tbody>
                {saleDetails.map((detail, ind) => {
                    const total = Number(detail.sale_prod_total) || 0;
                    const qty = Number(detail.sale_qty) || 0;
                    const rate = Number(detail.sale_rate) || 0;
                    const baseTotal = getBaseAmount(total);
                    const vatAmount = calculateVat(total);
                    const priceInclVat =
                        vatOption === 'A'
                            ? total + vatAmount
                            : total;

                    return (
                        <tr key={ind}>
                            <td style={{ textAlign: 'left' }}>{ind + 1}</td>
                            <td style={{ textAlign: 'left' }}>{detail.prod_cat_name}</td>
                            <td style={{ textAlign: 'left' }}>{detail.prod_name}</td>
                            <td style={{ textAlign: 'left' }}>{detail.prod_brand_name}</td>
                            <td>{detail.prod_unit_name}</td>
                            <td>{qty}</td>
                            <td>{format((vatOption === 'B' && qty ? baseTotal / qty : rate).toFixed(2))}</td>
                            <td style={{ textAlign: 'right' }}>{format(baseTotal.toFixed(2))}</td>
                            {ind === 0 && (
                                <td rowSpan={saleDetails.length}>{getVatPercentage()}</td>
                            )}
                            <td>{format(vatAmount.toFixed(2))}</td>
                            <td>{format(priceInclVat.toFixed(2))}</td>
                        </tr>
                    );
                })}
                <tr>
                    <td colSpan="7" style={{ textAlign: 'right', fontWeight: 'bold' }}>Sub Total</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                        {format(subTotalTotal.toFixed(2))}
                    </td>
                    <td style={{ fontWeight: 'bold' }}></td>
                    <td style={{ fontWeight: 'bold' }}>
                        {format(subTotalVat.toFixed(2))}
                    </td>
                    <td style={{ fontWeight: 'bold' }}>
                        {format(subTotalPrice.toFixed(2))}
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const useStyles = makeStyles((theme) => ({}));

export default InvoiceBody;
